import {useAppSelector} from "../store/hooks";

export const useIsAuthenticated = (): boolean => {
    return useAppSelector((state) => state.user.authenticated);
}

export const useGetUser = () => {
    return useAppSelector((state) => state.user);
}